import * as API from '@/api';
import DEFINES from '@/defines';
import router from '../../router';
import {getField, updateField} from 'vuex-map-fields';
import {setAccessTokenCookie, unsetAccessTokenCookie} from '@/helper';
import i18n from '@/i18n';

//initial state
function initialState () {
  return {
    key: null,
    secret: null,
    selected_company_id: null,
    session_mode: null,
    previous_session: {
      key: null,
      secret: null,
      session_mode: null,
    },
    upload_link: null,
  };
}
const state = initialState ();

// actions

const actions = {
  async register (context, payload) {
    var response = await API.auth.register (payload);
    context.commit ('set_key', {
      key: response.key,
    });
    return response;
  },

  async login (context, payload) {
    var response = await API.auth.login (payload);
    context.commit ('set_key', {
      key: response.key,
    });
    return response;
  },

  async logout (context, payload) {
    try {
      //logout when you user is loggedin
      await API.auth.logout (payload);
      //unset Access token from cookies
      unsetAccessTokenCookie ();
    } catch (e) {
      console.error (e);
    } finally {
      context.dispatch ('resetAll', {}, DEFINES.USE_ROOT);
      router.push ({path: '/login'});
    }
  },

  async verifyOtp (context, payload) {
    var response = await API.auth.verifyOtp (payload);
    context.commit ('set_secret', {
      secret: response.secret,
    });
    //set access token in cookies
    setAccessTokenCookie ();
    // set user profile
    context.commit (
      'user/set_profile',
      {
        user: response.user,
      },
      DEFINES.USE_ROOT
    );
    // set user companies
    context.commit (
      'company/set_list',
      {
        companies: response.companies,
      },
      DEFINES.USE_ROOT
    );

    return response;
  },

  async loginSuccess (context) {
    //    await context.dispatch('plan/getPlans',{}, DEFINES.USE_ROOT)
    if (router.currentRoute.query.redirect) {
      return router.push (router.currentRoute.query.redirect);
    }

    var all_companies = context.rootGetters['company/getCompanies'];
    /**
         * if user has one company then return to company dashboard else return to company list
         */

    all_companies.length == 1
      ? router.push ({
          name: 'CompanyDashboard',
          params: {company_id: all_companies[0]['id']},
        })
      : router.push ({name: 'Companies'});

    context.dispatch (
      'app/showMessage',
      {
        message: i18n.t ('registration.success'),
        color: DEFINES.SNACKBAR_SUCCESS_COLOR,
      },
      DEFINES.USE_ROOT
    );
  },

  async loginWithUploadLink (context, payload) {
    // reset state first
    context.dispatch ('resetAll', {}, DEFINES.USE_ROOT);

    var response = await API.auth.loginWithUploadLink (payload);

    context.dispatch (
      'app/updateLocale',
      {
        locale: response.language,
      },
      DEFINES.USE_ROOT
    );

    context.commit ('set_key', {
      key: response.key,
    });
    context.commit ('set_secret', {
      secret: response.secret,
    });
    context.commit ('set_session_mode', {
      session_mode: response.session_mode,
    });
    // set user profile
    context.commit (
      'user/set_profile',
      {
        user: response.user,
      },
      DEFINES.USE_ROOT
    );

    context.commit (
      'company/set_selected',
      {
        selected_company_id: response.upload_link.film.company_id,
      },
      DEFINES.USE_ROOT
    );

    context.commit ('set_upload_link', {
      upload_link: response.upload_link,
    });
    return response;
  },
};

//getters

const getters = {
  getField,
  getSession (state) {
    var data = {};
    data.key = state.key;
    data.secret = state.secret;
    data.session_mode = state.session_mode;
    return data;
  },
  getSessionMode (state) {
    return state.session_mode;
  },
  getPreviousSession (state) {
    return state.previous_session;
  },
  isUploadModeLogin (state) {
    return state.upload_link != null;
  },
};

// mutations
const mutations = {
  async set_key (state, payload) {
    state.key = payload.key;
  },

  async set_upload_link (state, payload) {
    state.upload_link = payload.upload_link;
  },

  async set_secret (state, payload) {
    state.secret = payload.secret;
  },

  async set_session_mode (state, payload) {
    state.session_mode = payload.session_mode;
  },

  async set_previous_session (state, payload) {
    state.previous_session.key = payload.key;
    state.previous_session.secret = payload.secret;
    state.previous_session.session_mode = payload.session_mode;
  },

  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
